var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLike01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "square",
  strokeWidth: 1.2,
  d: "m5.412 7.848 2.51-4.013a1.08 1.08 0 0 1 .93-.514v0a1.097 1.097 0 0 1 1.137 1.087v2.877h4.34a1.137 1.137 0 0 1 1.087 1.305l-.791 5.1a1.13 1.13 0 0 1-1.117.99H7.023a2 2 0 0 1-.89-.208l-.711-.356"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.414,
  d: "M5.412 7.848v6.238"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M3.068 7.848h2.343v6.238H3.068a.494.494 0 0 1-.494-.495V8.343a.494.494 0 0 1 .494-.494"
})));
export default SvgIconLike01;